module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
    attrs: {
      "title": "Cidades"
    }
  }), _vm._v(" "), _c('el-card', {
    staticClass: "el-card__save_form box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Dados das Cidades")])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "20%"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSend($event)
      }
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.form.state_id.$error
    },
    attrs: {
      "label": "Estado"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "filterable": "",
      "placeholder": "Selecione um estado",
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "input": function($event) {
        _vm.$v.form.state_id.$touch()
      }
    },
    model: {
      value: (_vm.form.state_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "state_id", $$v)
      },
      expression: "form.state_id"
    }
  }, _vm._l((_vm.dependencies.states), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })), _vm._v(" "), (_vm.$v.form.state_id.$error) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("\n                    Esse campo é obrigatório\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.form.name.$error
    },
    attrs: {
      "label": "Nome"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 200
    },
    on: {
      "input": function($event) {
        _vm.$v.form.name.$touch()
      }
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
    attrs: {
      "event-click": _vm.onSend,
      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
      "is-submitted": _vm.isSubmitted
    }
  }), _vm._v(" "), _c('form-cancel-button', {
    attrs: {
      "route-name": "city.index"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58a7723c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/city/components/Form.vue
// module id = 752
// module chunks = 2